<template>
    <div class="public-profile-wrapper">
        <div class="flex flex-column md:px-4 lg:flex-row gap-4 mt-4 justify-content-center">
            <div class="w-full md:p-2">
                <div class="py-4">
                    <div class="grid" v-if="enrolledTutors?.length > 0">
                        <div v-for="(tutor, index) in enrolledTutors" :key="index" class="col-12 lg:col-3 mb-3">
                            <div class="surface-section">
                                <div class="flex align-items-center gap-3 mb-2">
                                    <img :src="tutor.profilePhoto || blankProfile" class="w-full h-full"
                                        :alt="tutor.tutorName" />
                                </div>
                                <div>
                                    <div>
                                        <div class="flex flex-wrap justify-content-between align-items-center">
                                            <div class="Raleway font-semibold mb-2">{{ tutor.tutorName || 'N/A' }}</div>
                                            <Button icon="pi pi-comments" label=""
                                                class="p-button-text Caption mb-2 black-btn " />
                                        </div>

                                        <div class=" Raleway-Medium mb-2">Professional teacher - {{
                                            tutor.location || 'N/A' }}
                                        </div>
                                    </div>
                                    <div class="flex flex-column gap-1 text-sm">
                                        <div class="flex align-items-center gap-2">
                                            <span class="Raleway-Medium mb-2">{{ tutor.tutorType || 'N/A' }}</span>
                                        </div>
                                    </div>
                                    <div class="flex flex-wrap justify-content-between my-4">
                                        <Button label="View Profile" class="accent-button mb-2 " />
                                        <Button label="End Classes" class="accent-button-transparent mb-2 " />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="text-center">
                            <i class="pi pi-inbox" style="font-size: 2rem; color: var(--surface-400)"></i>
                            <p class="mt-2 text-color-secondary">No enrolled tutors found</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, onMounted } from "vue";
import Button from 'primevue/button';
import { generateSignedUrl } from '@/api/storage';
import blankProfile from '@/assets/blank-profile.png';
const props = defineProps({
    enrolledTutors: null
})
onMounted(async () => {
    if (!props.enrolledTutors?.length) return;

    for (const tutor of props.enrolledTutors) {
        if (tutor.tutorPhotoURL && !tutor.profilePhoto) {
            try {
                tutor.profilePhoto = await generateSignedUrl(tutor.tutorPhotoURL);
            } catch (err) {
                tutor.profilePhoto = blankProfile;
            }
        } else if (!tutor.profilePhoto) {
            tutor.profilePhoto = blankProfile;
        }
    }
});

</script>

<style scoped>
.black-btn {
    color: var(--gray-600) !important;
}

.black-btn:hover {
    color: var(--gray-600) !important;
    background-color: var(--black-50) !important;
}
</style>